import styled from "@emotion/styled/macro";
import InputField from "@metacrm/metacrm-material-ui/dist/InputField";
import Box from "@mui/material/Box";
import isStyledPropsValid from "utils/isStyledPropsValid";

export const StyledHint = styled(Box, {
  shouldForwardProp: isStyledPropsValid,
})(({ theme }) => ({
  borderRadius: "4px",
  border: "1px solid #7B61FF",
  background: "rgba(123, 97, 255, 0.15)",
  marginBottom: "8px",
  padding: "16px",
  display: "flex",
}));

export const StyledAiToolWhiteContainer = styled(Box, {
  shouldForwardProp: isStyledPropsValid,
})(({ theme }) => ({
  borderRadius: "4px",
  boxShadow: " 0px 0px 20px 0px rgba(0, 0, 0, 0.05)",
}));

export const StyledAiSettingTitle = styled(Box, {
  shouldForwardProp: isStyledPropsValid,
})(({ theme }) => ({
  color: "#555",
  fontSize: "14px",
  fontWeight: 700,
}));

export const StyledAiSettingDescription = styled(Box, {
  shouldForwardProp: isStyledPropsValid,
})(({ theme }) => ({
  color: "#777",
  fontSize: "14px",
  fontWeight: 500,
}));

export const StyledAiSettingOptions = styled(Box, {
  shouldForwardProp: isStyledPropsValid,
})(({ theme, checked }) => ({
  borderRadius: "4px",
  border: checked ? "1px solid #7B61FF" : "1px solid #E6E6E6",
  background: "#FFF",
  padding: "16px",
  gap: "0 8px",
  color: "#555",
  fontWeight: 700,
  marginTop: "8px",
  display: "flex",
  alignItems: "center",
  cursor: "pointer",
}));

export const StyledAiMessage = styled(Box, {
  shouldForwardProp: isStyledPropsValid,
})(({ theme, checked, sx }) => ({
  borderRadius: "0 7px 7px 7px",
  background: "rgba(85, 85, 85, 0.05)",
  padding: "10.5px",
  width: "fit-content",
  maxWidth: "90%",
  color: "#222",
  marginTop: "8px",
  position: "relative",
  fontSize: "14px",
  fontWeight: 400,
  overflowWrap: "anywhere",
  wordBreak: "normal",
  whiteSpace: "normal",
  ...sx,

  "& ul": {
    paddingLeft: "16px",
  },
  "& li": {
    listStyle: "disc",
    marginBottom: "8px",
  },
}));

export const StyledUserMessage = styled(Box, {
  shouldForwardProp: isStyledPropsValid,
})(({ theme, checked }) => ({
  borderRadius: "7px 7px 0 7px",
  background: "rgba(123, 97, 255, 0.15)",
  padding: "10.5px",
  width: "fit-content",
  marginLeft: "auto",
  maxWidth: "90%",
  color: "#222",
  fontSize: "14px",
  fontWeight: 400,
  overflowWrap: "anywhere",
  wordBreak: "normal",
  whiteSpace: "normal",
}));

export const StyledSystemMessage = styled(Box, {
  shouldForwardProp: isStyledPropsValid,
})(({ theme }) => ({
  fontSize: 12,
  padding: "12px",
  margin: "0 auto",
  color: "#777",
  marginBottom: "16px",
  textAlign: "center",
  overflowWrap: "anywhere",
  wordBreak: "normal",
  whiteSpace: "normal",
}));

export const StyledSendInput = styled(InputField, {
  shouldForwardProp: isStyledPropsValid,
})(({ theme }) => ({
  flex: 1,
  display: "flex",
  "& .MuiInputBase-root": {
    padding: 0,
    fontSize: "16px",
    backgroundColor: "transparent",

    "&.Mui-disabled": {
      background: "none",
    },
  },

  "& .MuiInputBase-input": {
    maxHeight: "35px",
    overflowY: "auto !important",
    lineHeight: 1.5,
    color: theme.isLight
      ? theme.customColors.grey[500]
      : theme.customColors.white,
    "&::placeholder": {
      fontSize: "16px",
    },
  },

  "& .MuiOutlinedInput-notchedOutline": {
    border: "none !important",
    boxShadow: "none !important",
  },
}));

export const StyledUserOptionsMessage = styled(Box, {
  shouldForwardProp: isStyledPropsValid,
})(({ theme, checked }) => ({
  borderRadius: "7px 7px 0 7px",
  border: "1px solid #777",
  padding: "10.5px",
  width: "fit-content",
  maxWidth: "90%",
  marginTop: "3.5px",
  textAlign: "flex-end",
  cursor: "pointer",
  color: "#555",
  fontSize: "14px",
  fontWeight: 400,
}));

export const StyledMessageTime = styled(Box, {
  shouldForwardProp: isStyledPropsValid,
})(({ theme, isAdminResponse = false }) => ({
  color: "#A5A5A5",
  fontWeight: 400,
  fontSize: "10px",
  marginTop: "4px",
  width: "fit-content",
  marginLeft: isAdminResponse ? 0 : "auto",
}));

const floatUpDown = `
  @keyframes floatUpDown {
    0%, 100% {
      transform: translateY(0);
    }
    50% {
      transform: translateY(-4px);
    }
  }
`;

// 2. 建立三個小圓點上下浮動的容器
export const StyledAiThinking = styled(Box, {
  shouldForwardProp: isStyledPropsValid,
})(({ theme }) => ({
  display: "inline-flex",
  alignItems: "center",
  gap: "4px",

  // 讓每個小圓點都能套用相同基礎動畫
  "& span": {
    width: "6px",
    height: "6px",
    borderRadius: "50%",
    backgroundColor: "#777", // 可依需求調整顏色
    animation: "floatUpDown 1s infinite ease-in-out",
  },

  // 順序錯開，產生依序上下浮動的效果
  "& span:nth-of-type(2)": {
    animationDelay: "0.2s",
  },
  "& span:nth-of-type(3)": {
    animationDelay: "0.4s",
  },

  // 注入 keyframes
  [`${floatUpDown}`]: {},
}));
